<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="tx"><span epub:type="pagebreak" id="pageix" title="ix"></span></p>
<p class="_toc" id="_idParaDest-4">Contents<a id="_idTextAnchor000"></a></p>
<p class="FM_TOC_Italics2"><a href="#/OCC#_idTextAnchor001"><span class="Italic">Acknowledgments</span></a> </p>
<p class="FM_TOC_Italics1"><a href="#/OCC1#_idTextAnchor002"><span class="Italic">Charmed Circle  Foreword</span></a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 1: <br/></span><a href="#/OCC2#_idTextAnchor004">An Introduction to the Book (and the Author)</a></p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 2: <br/></span><a href="#/OCC3#_idTextAnchor008">Getting Our Bearings, Knowing Our Terms</a></p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 3: <br/></span><a href="#/OCC4#_idTextAnchor011">Embodiment as Magical Praxis</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 4: <br/></span><a href="#/OCC5#_idTextAnchor015">Gender in Theory  and Practice</a> </p>
<p class="FM_TOC_Chpts"><span epub:type="pagebreak" id="pagex" title="x"><span class="Brandon _idGenCharOverride-1">Chapter 5: <br/></span><a href="#/OCC6#_idTextAnchor017">Queerness and the Charmed Circle</a> </span></p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 6: <br/></span><a href="#/OCC7#_idTextAnchor021">Safer Sex Magic for Beginners (and Experts)</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 7: <br/></span><a href="#/OCC8#_idTextAnchor026">Form Follows Function:  Toward a Consent-Based Magical Praxis</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 8: <br/></span><a href="#/OCC9#_idTextAnchor029">Between the Mundane and the Divine: On Negotiating Consent with Gods</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 9: <br/></span><a href="#/OCC10#_idTextAnchor031">Queering Your Praxis: Developing and Adapting Magical Practices</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 10: <br/></span><a href="#/OCC11#_idTextAnchor034">Greater Than One: Thoughts on Politics, Power, and Community</a></p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Chapter 11: <br/></span><a href="#/OCC12#_idTextAnchor037">An Ending and a Beginning: What Lies Beyond the Circle</a></p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Appendix A: <br/></span><a href="#/OCC13#_idTextAnchor039">Recommended Reading and Listening</a> </p>
<p class="FM_TOC_Chpts"><span class="Brandon _idGenCharOverride-1">Appendix B: <br/></span><a href="#/OCC14#_idTextAnchor043">Queer Magical Groups and Events</a></p>
<p class="FM_TOC_Italics2"><a href="#/OCC15#_idTextAnchor045"><span class="Italic">Bibliography</span></a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?efc15d6a